



























import Vue from "vue";
import { onMounted } from "@vue/composition-api";
import ReportsTable from "./pdf-reports-table/ReportsTable.vue";
import { state } from "./data/state";
import ReportsTabs from "./ReportsTabs.vue";
import CsvReportsTable from "./csv-reports/CsvReportsTable.vue";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import JustificationDashboard from "@/views/customize/in-motion/justification/index.vue";
import ScheduledReportsDashboard from "./scheduled-reports/ScheduledReportsDashboard.vue";
import ExecutiveReports from "./executive-reports/ExecutiveReports.vue";
export default Vue.extend({
  components: {
    ReportsTable,
    ReportsTabs,
    CsvReportsTable,
    PageWithMainContainer,
    JustificationDashboard,
    ScheduledReportsDashboard,
    ExecutiveReports,
  },
  setup(props, { root: { $router } }) {
    const { current_tab, tabs, set_current_tab } = state;

    onMounted(() => {
      state.init();
      const nav_to_tab = $router.currentRoute.query.tab;
      if (nav_to_tab) {
        switch (nav_to_tab) {
          case "events":
            set_current_tab(
              tabs.value.find((f) => f.id === "events_justification")!
            );
            break;
          case "scheduled":
            set_current_tab(tabs.value.find((f) => f.id === "scheduled")!);
            break;
          case "pdf":
            set_current_tab(tabs.value.find((f) => f.id === "pdf")!);
            break;
          case "executive":
            set_current_tab(tabs.value.find((f) => f.id === "executive")!);
            break;
          case "csv":
          default:
            set_current_tab(tabs.value.find((f) => f.id === "csv")!);
            break;
        }
      }
    });

    return { current_tab };
  },
});
